import update from 'immutability-helper';
import { iList } from "../../shared/interfaces";
import { iKmlFile, watchKmlFiles } from "../../shared/db/kml-db";

class ActionsClass {
    SET_FILES = (files: iList<iKmlFile>) => ({ type: 'KML_SET_FILES', files });
    SET_UPLOADING = (isUploading: boolean) => ({ type: 'KML_SET_UPLOADING', isUploading });
    SET_MAP_VISIBILITY = (isVisible: boolean) => ({ type: 'KML_SET_MAP_VISIBILITY', isVisible });
}

export const KmlActions = new ActionsClass();

export interface iKmlState {
    files: iList<iKmlFile>;
    isUploading: boolean;
    isMapVisible: boolean;
}

const initialState: iKmlState = {
    files: {},
    isUploading: false,
    isMapVisible: false
};

export const kmlReducer = (state: iKmlState = initialState, action: any) => {
    switch (action.type) {
        case 'KML_SET_FILES':
            return update(state, {
                files: { $set: action.files }
            });

        case 'KML_SET_UPLOADING':
            return update(state, {
                isUploading: { $set: action.isUploading }
            });

        case 'KML_SET_MAP_VISIBILITY':
            return update(state, {
                isMapVisible: { $set: action.isVisible }
            });

        default:
            return state;
    }
};

export const subscribeToKmlFiles = () => (dispatch: any) => {
    const unsubscribe = watchKmlFiles((files) => {
        dispatch(KmlActions.SET_FILES(files));
    });

    return unsubscribe;
};